'use client';

import AccountPageMenu from '@/components/AccountPageMenu';
import { fullPageLoadingIndicator } from '@/components/LoadingIndicator';
import { useAccountInfluencerPage } from '@/hooks/AccountInfluencerPage/useAccountInfluencerPage';
import { useToasts } from '@/hooks/Toasts/useToasts';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import { useEffect } from 'react';
import CommissionInfo from './commissionInfo';
import InfluencerForm from './influencerForm';

const CommissionDetail = dynamic(() => import('./commissionDetail'), { ssr: false });

const AccountInfluencerPage = () => {
  const PAGE_TITLE = 'Influencer Program';

  const talonProps = useAccountInfluencerPage({});

  const [, { addToast }] = useToasts();

  const { loading, influencerData, onPaypalAccountSubmit, response } = talonProps;

  const commissionContent = influencerData ? (
    <CommissionDetail influencerData={influencerData} />
  ) : (
    <p className='mt-5 text-base leading-6'>Please join our influencer program to earn commission.</p>
  );

  useEffect(() => {
    if (response && response.code === '200') {
      addToast({
        type: 'success',
        message: 'Sumbit comentt success!',
        timeout: 3000,
      });
    }
  }, [addToast, response]);

  if (loading) {
    return fullPageLoadingIndicator;
  }

  const dashboardContent = influencerData ? (
    <>
      <InfluencerForm
        influencerData={influencerData}
        onPaypalAccountSubmit={onPaypalAccountSubmit}
      />
      <CommissionInfo influencerData={influencerData} />
    </>
  ) : (
    <div className='py-[60px]'>
      <h2 className='text-center text-base leading-[22px]'>Become a aw bridal influencer!</h2>
      <Link
        className='aw-default-link mx-auto mt-[30px] flex h-[45px] w-[200px] items-center justify-center rounded-[3px] text-sm '
        href='/influencer-program'
      >
        JOIN US
      </Link>
    </div>
  );

  return (
    <div className='mx-auto max-w-site  px-2.5 pb-[101px] pt-5 lg_flex lg_justify-between lg_px-0 lg_pb-11 lg_pt-[60px]'>
      <AccountPageMenu />
      <div className='shrink pt-[30px] lg_basis-[1100px] lg_pt-0'>
        <h1 className='text-center font-Shango text-[28px] leading-[34px]'>{PAGE_TITLE}</h1>

        <div className='mt-[38px] lg_mt-[68px]'>
          <p className='border-b-1 border-solid border-E7DED5 py-2.5 text-lg font-medium leading-[26px]'>
            My Dashboard
          </p>
          <div className='mt-5'>{dashboardContent}</div>
          <p className='mt-[30px] border-b-1 border-solid border-E7DED5 py-2.5 text-lg font-medium leading-[26px] lg_mt-[50px] '>
            Commission Details
          </p>
          {commissionContent}
        </div>
      </div>
    </div>
  );
};

export default AccountInfluencerPage;
